import React, { useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const OfflineNotifier = () => {
  const intervalRef = useRef(null);

  useEffect(() => {
    const checkStatus = () => {
      if (!navigator.onLine) {
        toast.error("You're offline. Please check your internet connection.");
      }
    };

    // Initial check
    if (!navigator.onLine) checkStatus();

    // Start interval
    intervalRef.current = setInterval(checkStatus, 10000); // every 10 seconds

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return <ToastContainer position="top-right" autoClose={3000} />;
};

export default OfflineNotifier;
